import type { TFunction } from '@aikoa/i18n/react'
import { type QuestionnaireData } from '../questionnaires/types.ts'

export function getFeedbackQuestionnaireData(t: TFunction<'feedback'>): QuestionnaireData {
  return {
    name: t(($) => $.questionnaire.name),
    questions: [
      {
        id: 'timing' as const,
        order: 0,
        type: 'multi-choice',
        question: t(($) => $.questionnaire.questions.timing.question),
        config: {
          options: [
            { label: t(($) => $.questionnaire.questions.timing.options['1']), value: 1 },
            { label: t(($) => $.questionnaire.questions.timing.options['0.8']), value: 0.8 },
            { label: t(($) => $.questionnaire.questions.timing.options['0.6']), value: 0.6 },
            { label: t(($) => $.questionnaire.questions.timing.options['0.3']), value: 0.3 },
            { label: t(($) => $.questionnaire.questions.timing.options['0']), value: 0 },
          ],
        },
      },
      {
        id: 'sales_status' as const,
        order: 1,
        type: 'multi-choice',
        question: t(($) => $.questionnaire.questions.sales_status.question),
        config: {
          options: [
            {
              label: t(($) => $.questionnaire.questions.sales_status.options.pre_market),
              value: 1,
            },
            {
              label: t(($) => $.questionnaire.questions.sales_status.options.public_sale),
              value: 2,
            },
            {
              label: t(($) => $.questionnaire.questions.sales_status.options.no_preference),
              value: 3,
            },
          ],
        },
      },
    ],
  }
}
